export default __webpack_public_path__ + "static/media/author-1.5144e7f0.jpg";